import { Component, OnInit } from '@angular/core';
import { CrudService } from '../crud.service';
@Component({
  selector: 'app-why-did-we-choose-bba-in-computer-applications',
  templateUrl: './why-did-we-choose-bba-in-computer-applications.component.html',
  styleUrls: ['./why-did-we-choose-bba-in-computer-applications.component.scss']
})
export class WhyDidWeChooseBbaInComputerApplicationsComponent implements OnInit {

  constructor(private crudService: CrudService) { }
  baseUrl = this.crudService.baseUrl;

  ngOnInit(): void {
  }

}
